export enum TagVariant {
  Primary = 'Primary',
  Subtle = 'Subtle',
  Ghost = 'Ghost',
  Outline = 'Outline',
}
